import React, {useState} from 'react';
import firebase from 'firebase';
import styled from 'styled-components'

const modalObservacion = ({close, data, update}) => {
	const [comentarioAdmin, setComentarioAdmin] = useState(data.comentarioAdmin);

	const sendComentarioAdmin=()=>{
		firebase.database().ref('ProgramacionDia').child(data.key).update({comentarioAdmin});
		update(comentarioAdmin);
		close(false);
	}

    return (
    <Wrapper >
        <div className='modalObservacion'>
            <header>
                <div>
                    <h3 className='title-blue' style={{ display:'inline-block' }} >Observaciones</h3>
                </div>
                <div className='text-info' >para el viaje</div>
                <div className='text-info, line' ><strong>{data.tipoViaje}</strong></div>
            </header>
            <div className='contenido'>
                <div className="contenido-top">
                    <div className="titulo"> 
                        <p>Fecha</p> 
                        <strong>{data.fecha}</strong> 
                    </div>
                    <div className="titulo">
                        <p>Tipo</p> 
                        <strong>{data.tipoTrayecto}</strong> 
                    </div>
                    <div className="titulo">
                        <p>Estado</p>
                        <strong>{data.estado}</strong> 
                    </div>
                    <div className="titulo">
                        <p>Hora de inicio real</p>
                        <strong>{data.horaInicioReal}</strong> 
                    </div>
                    <div className="titulo">
                        <p>Hora de final real</p>
                        <strong>{data.horaLlegadaReal}</strong> 
                    </div>
                    <div className="titulo">
                        <p>Vehiculo</p>
                        <strong>{data.equipo}</strong> 
                    </div>
                    <div className="titulo">
                        <p>Conductor</p> 
                        <strong>{data.conductor}</strong> 
                    </div>
                </div>
                <div className="contenido-body">
                    <div className="cont">
                        <p className="title">Observaciones</p>
                        <strong>{data.comentario}</strong> 
                    </div>
                </div>
                <div className="contenido-body">
                    <div className="cont">
                        <p className="title">
                            Observacion Administrativa
                        </p>
                        <div className="cont-obser">
                            <textarea className="observacion" defaultValue={data.comentarioAdmin} onChange={e=>setComentarioAdmin(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <button 
					onClick={()=>close(false)}
                    className="btn btn-secondary">
                    Cancelar
                </button>
                <button 
					onClick={sendComentarioAdmin}
                    className="btn btn-success">
                    Añadir Observacion
                </button>

            </footer>
        </div>
        <div className='background' onClick={()=>close(false)} /> 
    </Wrapper>
    )
}


const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    position: fixed;
    background: rgba(0,0,0,0.2);
    width:100vw;
    height:100vh;
    top:0;
    left: 0;
    z-index: 25;

    .modalObservacion{
        background: white;
        width:80vw;
        /* min-width: 789px; */
        /* height:60vh; */
        /* min-height: 476px; */
        border-radius: 10px;
        border: 1px solid #C4C4C4;
        z-index:26;
    }

    .background{
        position:absolute;
        width:100%;
        height:100%;
    }

    header {
        margin-top: 2em;

        div:first-child{
            display: flex;
            justify-content:center;
            align-items:flex-end;
            margin-bottom:0.5em;
    
        }

        .text-info {
            text-align:center;
        }

        .line {
            text-align:center;
            margin-bottom: 1em;
        }

    }

    h4 {
        text-align:center;
        margin:2em 0;
    }

    .contenido{
        display:flex;
        justify-content: space-evenly;
        flex-wrap:wrap;

        .contenido-top{
            display: flex;
            flex-wrap:wrap;
            width: 81%;
            margin-top: 25px;
            border-bottom: #cccc 2px solid;
        }

        .contenido-body {
            width: 81%;
            margin-top: 24px;
            border-bottom: #cccc 2px solid;
        }

        .cont{
            margin-bottom: 23px;
        }

        .titulo {
            font-family: Lato;;
            font-size: 14px;
            color: #7D7D7D;
            min-width: 7em;
            width: 20%;
            margin-bottom: 30px;
        }
        .title {
			margin-bottom: 0.5rem;
            font-family: Lato;
            font-size: 14px;
            color: #7D7D7D;
        }
    }

    .cont-obser{
        display: flex;
        flex-direction: column;
    }

    footer {
        display:flex;
        justify-content: center;
        margin:2em 0 2em;

        button {
            margin:0.5em;

        }
    }
`
export default modalObservacion;


// WEBPACK FOOTER //
// ./src/Components/Reportes/Components/ModalObservacion.js